/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useTranslation } from "react-i18next";

import { ICON_DEFAULT_STYLE } from "@/shared/constants";

import { EditIcon } from "@dotnet/telematics-design-system";

import ListChoice from "../../../../components/ListChoice/ListChoice";

interface EditChoiceProps {
  onButtonClick: () => void;
  testId?: string;
  dialog?: React.ReactNode;
}

const EditChoice = ({ testId, onButtonClick, dialog }: EditChoiceProps) => {
  const { t } = useTranslation();

  return (
    <>
      <ListChoice
        data-testid={testId ?? "edit-choice"}
        title={t("Details##edit")}
        iconLeft={
          <EditIcon css={css({ ...ICON_DEFAULT_STYLE, alignSelf: "center" })} />
        }
        onClick={onButtonClick}
        alignIconCenter
      />
      {dialog}
    </>
  );
};

export default EditChoice;
